import {TOGGLE_MODAL, TOGGLE_MODAL_COMMENT} from '../constants'

export function modalAction(state = false, action) {
    switch (action.type){
        case TOGGLE_MODAL:
            return action.isOpen;
        default:
            return state
    }

}

export function commentModal(state = false, action) {
    switch (action.type){
        case TOGGLE_MODAL_COMMENT:
            return action.isOpen;
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/modal.js